import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "@otto/design/fonts.css";
import "@otto/design/tokens.css";
import "@otto/design/base.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Element #root fehlt in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
